module.exports = __webpack_public_path__ + "src/assets/games/56/4.png";